import { apiClient } from '@shared/api/client';
import type { AuthUser, LoginResponse } from '../types';

/** Clé de stockage du token JWT. */
export const TOKEN_STORAGE_KEY = 'receiptai.auth.token';

/** Connecte un utilisateur et renvoie token + profil. */
export function login(email: string, password: string): Promise<LoginResponse> {
  return apiClient.post<LoginResponse>('/auth/login', { email, password });
}

/** Récupère l'utilisateur courant à partir du token en cours. */
export function fetchCurrentUser(): Promise<{ user: AuthUser }> {
  return apiClient.get<{ user: AuthUser }>('/auth/me');
}

/** Lit le token persisté (localStorage). */
export function getStoredToken(): string | null {
  try {
    return window.localStorage.getItem(TOKEN_STORAGE_KEY);
  } catch {
    return null;
  }
}

/** Persiste le token. */
export function storeToken(token: string): void {
  try {
    window.localStorage.setItem(TOKEN_STORAGE_KEY, token);
  } catch {
    // Stockage indisponible : ignoré.
  }
}

/** Supprime le token persisté. */
export function clearStoredToken(): void {
  try {
    window.localStorage.removeItem(TOKEN_STORAGE_KEY);
  } catch {
    // Stockage indisponible : ignoré.
  }
}
